// import { IEmailExists } from 'modules/authModule/types/emailValidType'
// import { IPasswordChange } from 'modules/authModule/types/passwordChangeType'
const groupPrefix = 'auth'

export const apiAuth = {
	login: async (login: string, password: string) => {
		const obj = { login, password }
		const data = await apiCommon<IUser>(`${groupPrefix}/login`, { method: 'POST', body: userToJSON(obj) })
		return data
	},

	register: async (email: string, password: string, phoneNumber: string, name: string, lastName: string) => {
		const obj = {
			email,
			password,
			phone_number: phoneNumber,
			name,
			last_name: lastName,
		}
		const data = await apiCommon<IUser>(`${groupPrefix}/register`, { method: 'POST', body: userToJSON(obj) })
		return data
	},

	loginByCode: async (code: string) => {
		const { data } = await apiCommon<IUser>(`${groupPrefix}/exchange-code`, { method: 'POST', body: { code } })
		return data
	},

	setCookies: async () => {
		await apiCommon('sanctum/csrf-cookie', { method: 'GET' })
	},

	logout: async () => {
		await apiCommon(`${groupPrefix}/logout`, { method: 'POST' })
	},

	fetchUser: async () => {
		const { data } = await apiCommon<IUser>(`${groupPrefix}/me`, { method: 'GET' })
		return User(data)
	},

	updateUser: async (user: Partial<IUserModel>) => {
		const { data } = await apiCommon<IUser>('profile', { method: 'PATCH', body: userToJSON(user) })
		return User(data)
	},

	forgotPassword: async (email: string) => {
		const data = await apiCommon('auth/reset-password/send-email', { method: 'POST', body: { email } })
		return data
	},

	changePassword: async (token: string, email: string, password: string, passwordConfirmation: string) => {
		const obj = { token, email, password, passwordConfirmation }
		const data = await apiCommon<IPasswordChange>('auth/reset-password/validate', { method: 'POST', body: changePasswordToJSON(obj) })
		return data
	},

	changePasswordFromProfile: async (oldPassword: string, password: string, passwordConfirmation: string) => {
		const data = await apiCommon('auth/update-password', {
			method: 'POST',
			body: {
				password,
				password_old: oldPassword,
				password_confirmation: passwordConfirmation,
			},
		})
		return data
	},

	resendEmail: async () => {
		const data = await apiCommon(`${groupPrefix}/verification-email/resend`, { method: 'GET' })
		return data
	},

	loginBD: async (email: string, password: string) => {
		const obj = { email, password }
		const { data } = await apiCommon<IUser>(`${groupPrefix}/login-bd`, { method: 'POST', body: userToJSON(obj) })
		return User(data)
	},

	invokeLoginPhoneCode: async (phoneNumber: any) => {
		const { data } = await apiCommon<{ data: any }>(`${groupPrefix}/login-phone`, {
			method: 'POST',
			body: userLoginToJSON({ phoneNumber }),
		})
		return data
	},

	confirmLoginPhoneCode: async (phoneNumber: any, code: any) => {
		const { data } = await apiCommon<{ data: any }>(`${groupPrefix}/login-phone/confirm`, {
			method: 'POST',
			body: userLoginToJSON({ phoneNumber, code }),
		})
		return data
	},
	confirmRegisterPhoneCode: async (email: string, password: string, phoneNumber: string, name: string, lastName: string, code: string) => {
		const obj: IUserRegisterModel = {
			email,
			password,
			phoneNumber,
			name,
			lastName,
			code,
		}
		const data = await apiCommon<{ data: any }>(`${groupPrefix}/register/confirm`, {
			method: 'POST',
			body: userRegisterToJSON(obj),
		})
		return data
	},

	checkExistingEmail: async (email: string) => {
		const { data } = await apiCommon<{ data: string }>(`${groupPrefix}/check-email`, {
			method: 'POST',
			body: { email },
		})
		return data
	},

	checkExistingPhone: async (phone: string) => {
		const { data } = await apiCommon<{ data: string }>(`${groupPrefix}/check-phone`, {
			method: 'POST',
			body: { phone_number: phone },
		})
		return data
	},
}
